import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { MaterialList, MaterialQueryFilters, MaterialQueryFiltersDefaultValues } from '../../materials/material-list';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { NoResultsComponent } from '../../no-results/no-results.component';
import { MaterialsService } from 'src/app/services/materials.service';
import { Course, AddCourseDefaultValues } from '../course';
import { TagsService } from 'src/app/services/tag-service.service';

@Component({
    selector: 'app-course-materials',
    templateUrl: './course-materials.component.html',
    styleUrls: ['./course-materials.component.scss'],
    standalone: false
})

export class CourseMaterialsComponent implements OnInit {
  @Input() course: Course = AddCourseDefaultValues();
  @Input() hasEnrolledUsers: boolean = false;

  materiallist: MaterialList[] = [];
  totalRecords: number = 0;
  columnsToDisplay = [
    'checkbox','id','name','type','language','tags','status',
  ];
  //queryFilter:TagQueryFilter=TagQueryFilterDefaultValues();
  pageEvent!: PageEvent;
  @ViewChild('paginator') paginator!: MatPaginator;
  @ViewChild('noResults') noResults!: NoResultsComponent;
  @ViewChild('submitButton') submitButton !:ElementRef;
  information: string = '';
  queryFilter: MaterialQueryFilters = MaterialQueryFiltersDefaultValues();
  materialTypes: any[] = [];
  materialLanguage: any[] = [];
  materialStatus: any[] = [];
  Tags: any[] = [];
  selectedMaterials: any = [];
  disabledMaterials: any[] = [];

  constructor(public materialservice: MaterialsService,
    public tagService: TagsService)
  { }

  async ngOnInit(): Promise<void> {

    this.information="<h4>Status Definitions</h4>"+
      "<br/><span>Draft:</span> Material is in progress and not yet finalized. It can be edited and is not visible to participants. It can be associated with a draft course.<br/><br/>"+
      "<span>Published:</span> Material is finalized and available for use in published courses. It can be edited if it is associated with draft courses or published courses with zero enrolments.<br/><br/>"+
      "<span>Retired:</span> Material is no longer actively used for new courses but remains accessible to users who started using it while it was in the published status. It cannot be edited.";

    this.materialTypes = await this.materialservice.getMaterialTypes();
    this.materialservice.getMaterialLanguages().subscribe({
      next: (data) => this.materialLanguage = data,
    });

    await this.materialservice.getMaterialStatus("ALL").subscribe({
      next:(resp) => {
        this.materialStatus = resp;
      }
    });

    await this.tagService.getActiveTags().subscribe({
      next: (data) => {
        this.Tags = data;
      }
    });

    this.searchWithFilters();
  }

  handlePageEvent(e: PageEvent) {
    this.pageEvent = e;
    this.queryFilter.PageNumber = e.pageIndex
    this.queryFilter.PageSize = e.pageSize
    this.searchWithFilters();
  }

  private searchWithFilters() {

    this.materialservice.getAllMaterials(this.queryFilter).subscribe({
      next: (data) => {
        let headers = data.headers.get('x-pagination');
        if (headers) {
          let parsedHeaders = JSON.parse(headers);
          this.totalRecords = parsedHeaders.TotalCount;
          this.noResults.setTotal(this.totalRecords);
        }
        this.materiallist = data.body ? data.body : [];
      },
      error: (error) => {
        console.log(error);
      },
      complete: () => {
        this.selectedMaterials = this.course.materialId.map(option => ({
          ...option,
          disabled: false
        }));
        this.materiallist.forEach(item => {

          if(this.selectedMaterials.some((i: any) => i.id === item.id)) {
            item.disabled = true;
          }
        })

      }
    });
  }

  @HostListener('document:keypress', ['$event'])
	handleKeyboardEvent(event: KeyboardEvent): void {
	  if (event.key === 'Enter') {
		this.submitButton.nativeElement.click();
		event.preventDefault();
	  }
	}

  resetFilters() {
    this.queryFilter = MaterialQueryFiltersDefaultValues();
    this.searchWithFilters();
  }

  search() {
    this.searchWithFilters();
  }

  onCheckboxChange(material: MaterialList) {
    const index = this.selectedMaterials.findIndex((m:any) => m.id === material.id);

    if (index === -1) {
      this.selectedMaterials.push({id: material.id, disabled: false});
    } else {
      this.selectedMaterials.splice(index, 1);
    }

    this.course.materialId = this.selectedMaterials;
  }

  isMaterialSelected(material: MaterialList): boolean {
    return this.selectedMaterials.some((m: any) => m.id === material.id);
  }

  isMaterialCheckBoxDisabled(material: any): boolean {
    return this.disabledMaterials.some((m: any) => m.id === material.id);
  }
}
